<div class="graf">
  <app-resource-form-card
    [title]="service.title()"
    [resource]="service.resource"
    [detailed]="detailed()"
    [detailsButton]="true">
    @if (detailed()) {
      <div class="options">
        <p-calendar
          [(ngModel)]="rangeDates"
          selectionMode="range"
          [readonlyInput]="true"
          [showIcon]="true"
          [iconDisplay]="'input'"
          (onSelect)="onRangeDatesChange($event)">
        </p-calendar>
        @if (access()?.contract?.actions?.read) {
          @defer (when contracts()) {
            <p-dropdown
              [(ngModel)]="contract"
              [options]="contracts()"
              dataKey="_id"
              optionLabel="name"
              [showClear]="true"
              (onChange)="onContractChange($event)"
              placeholder="Contrato" />
          }
        }
        <!-- @if (access()?.branch?.actions?.read) {
          @defer (when branches()) {
            <p-dropdown
              [(ngModel)]="branch"
              [options]="branches()"
              dataKey="_id"
              optionLabel="name"
              (onChange)="onRangeDatesChange($event)"
              placeholder="Sucursal" />
          }
        } -->
        @if (access()?.user?.actions?.read) {
          @defer (when displays()) {
            <p-dropdown
              [(ngModel)]="display"
              [options]="displays()"
              dataKey="_id"
              optionLabel="username"
              [showClear]="true"
              (onChange)="onDisplayChange($event)"
              placeholder="Pantalla" />
          }
        }
      </div>
    }
    @defer (when basicData) {
      <div>
        <p-chart type="line" [data]="basicData" [options]="basicOptions"></p-chart>
      </div>
    }
  </app-resource-form-card>
</div>
